"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUserAgent = exports.initBowser = exports.setRootUAFlags = exports.getBrowserFlags = void 0;
const common_1 = require("@epic-core/common");
const bowser_1 = __importDefault(require("bowser"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const defaultEpicGamesNav = {
    browser: {},
};
/**
 * Return different browser client data like os, screen size and etc.
 * @param userAgent
 * @returns Browser
 */
const getBrowserFlags = (userAgent) => {
    console.warn("getBrowserFlags() is deprecated");
    const navBrowser = bowser_1.default.parse(userAgent);
    //the mobile and tablet flags are used to determine layout in SSR. They may have been set already based on cloudfront headers
    if (typeof navBrowser.mobile === "undefined") {
        navBrowser.mobile = Boolean(navBrowser.platform.type === "mobile");
    }
    if (typeof navBrowser.tablet === "undefined") {
        navBrowser.tablet = Boolean(navBrowser.platform.type === "tablet");
    }
    //set some easy to use flags for apps to quickly determine specific devices
    navBrowser.mac = Boolean(navBrowser.os.name === "macOS");
    navBrowser.linux = Boolean(navBrowser.os.name === "Linux");
    navBrowser.ios = Boolean(navBrowser.os.name === "iOS");
    navBrowser.firefox = Boolean(navBrowser.browser.name === "Firefox");
    navBrowser.android = Boolean(navBrowser.os.name === "Android");
    navBrowser.msie = Boolean(navBrowser.browser.name === "Internet Explorer");
    navBrowser.msedge = Boolean(navBrowser.browser.name === "Microsoft Edge");
    return navBrowser;
};
exports.getBrowserFlags = getBrowserFlags;
/**
 * Initialize the _epicGamesNav browser data for particular user agent
 * It contains different browser client data like os, screen size and etc.
 * @param userAgent
 * @returns
 */
const setRootUAFlags = (userAgent) => {
    console.warn("setRootUAFlags() is deprecated");
    if (!window_or_global_1.default._epicGamesNav || !userAgent) {
        return;
    }
    window_or_global_1.default._epicGamesNav.browser = bowser_1.default.parse(userAgent);
    const navBrowser = (0, exports.getBrowserFlags)(userAgent);
    Object.assign(window_or_global_1.default._epicGamesNav.browser, navBrowser);
};
exports.setRootUAFlags = setRootUAFlags;
/**
 * Initialize the _epicGamesNav property to root
 * It contains different browser client data like os, screen size and etc.
 * @param userAgent
 * @param force
 * @returns Browser
 */
const initBowser = (userAgent, force) => {
    console.warn("initBowser() is deprecated");
    if (!window_or_global_1.default._epicGamesNav) {
        window_or_global_1.default._epicGamesNav = defaultEpicGamesNav;
    }
    if ((force || !window_or_global_1.default._epicGamesNav.browser || !window_or_global_1.default._epicGamesNav.browser._init) &&
        window_or_global_1.default.navigator &&
        window_or_global_1.default.navigator.userAgent) {
        try {
            (0, exports.setRootUAFlags)(window_or_global_1.default.navigator.userAgent);
        }
        catch (e) {
            //
        }
        window_or_global_1.default._epicGamesNav.browser._init = true;
    }
    if (userAgent) {
        return (0, exports.getBrowserFlags)(userAgent);
    }
    return window_or_global_1.default._epicGamesNav.browser;
};
exports.initBowser = initBowser;
let userAgentSet = false;
const setUserAgent = () => {
    const body = window_or_global_1.default.document.body;
    if (!userAgentSet) {
        userAgentSet = true;
        for (const key in bowser_1.default) {
            if (typeof key === "string" &&
                typeof bowser_1.default[key] !== "function" &&
                key.length > 1 &&
                key !== "name" &&
                key !== "version") {
                (0, common_1.setDataAttribute)(body, key, true);
            }
        }
    }
};
exports.setUserAgent = setUserAgent;
//# sourceMappingURL=bowserUtils.js.map